import { gql } from "graphql.macro";

export const UpdateGeneralAppSettingMutation = gql`
    mutation updateGeneralAppSettingMutation($request: [AppSettingRequestModelInput]) {
        NearMissSaveAppSettings(request: $request)
    }
`;